import { gql } from 'src/__generated__';

const DATA_EXTRACTION_SUBSCRIPTION = gql(`#graphql
  subscription DataExtractionSubscription($userId: Int!) {
    dataExtraction(userId: $userId) {
      message
      success
      urlPDF
      urlExcel
      devices {
        id
        type
        name
      }
    }
  }
`);

export default DATA_EXTRACTION_SUBSCRIPTION;
